const testnetPackageIds = {
  DEEPBOOK_PACKAGE_ID: "0xc89b2bd6172c077aec6e8d7ba201e99c32f9770cdae7be6dac9d95132fff8e8e",
  REGISTRY_ID: "0x9162317a81a9eb66ecd42705529b2a39c7805f98f42312275c2e7a599d518437",
  DEEP_TREASURY_ID: "0x69fffdae0075f8f71f4fa793549c11079266910e8905169845af1f5d00e09dcb"
};
const mainnetPackageIds = {
  DEEPBOOK_PACKAGE_ID: "",
  REGISTRY_ID: "",
  DEEP_TREASURY_ID: ""
};
const testnetCoins = {
  DEEP: {
    address: `0x36dbef866a1d62bf7328989a10fb2f07d769f4ee587c0de4a0a256e57e0a58a8`,
    type: `0x36dbef866a1d62bf7328989a10fb2f07d769f4ee587c0de4a0a256e57e0a58a8::deep::DEEP`,
    scalar: 1e6
  },
  SUI: {
    address: `0x0000000000000000000000000000000000000000000000000000000000000002`,
    type: `0x0000000000000000000000000000000000000000000000000000000000000002::sui::SUI`,
    scalar: 1e9
  },
  DBUSDC: {
    address: `0xf7152c05930480cd740d7311b5b8b45c6f488e3a53a11c3f74a6fac36a52e0d7`,
    type: `0xf7152c05930480cd740d7311b5b8b45c6f488e3a53a11c3f74a6fac36a52e0d7::DBUSDC::DBUSDC`,
    scalar: 1e6
  },
  DBUSDT: {
    address: `0xf7152c05930480cd740d7311b5b8b45c6f488e3a53a11c3f74a6fac36a52e0d7`,
    type: `0xf7152c05930480cd740d7311b5b8b45c6f488e3a53a11c3f74a6fac36a52e0d7::DBUSDT::DBUSDT`,
    scalar: 1e6
  }
};
const mainnetCoins = {
  DEEP: {
    address: `0xdeeb7a4662eec9f2f3def03fb937a663dddaa2e215b8078a284d026b7946c270`,
    type: `0xdeeb7a4662eec9f2f3def03fb937a663dddaa2e215b8078a284d026b7946c270::deep::DEEP`,
    scalar: 1e6
  },
  SUI: {
    address: `0x0000000000000000000000000000000000000000000000000000000000000002`,
    type: `0x0000000000000000000000000000000000000000000000000000000000000002::sui::SUI`,
    scalar: 1e9
  },
  USDC: {
    address: `0x5d4b302506645c37ff133b98c4b50a5ae14841659738d6d733d59d0d217a93bf`,
    type: `0x5d4b302506645c37ff133b98c4b50a5ae14841659738d6d733d59d0d217a93bf::coin::COIN`,
    scalar: 1e6
  },
  WETH: {
    address: `0xaf8cd5edc19c4512f4259f0bee101a40d41ebed738ade5874359610ef8eeced5`,
    type: `0xaf8cd5edc19c4512f4259f0bee101a40d41ebed738ade5874359610ef8eeced5::coin::COIN`,
    scalar: 1e8
  },
  USDT: {
    address: `0xc060006111016b8a020ad5b33834984a437aaa7d3c74c18e09a95d48aceab08c`,
    type: `0xc060006111016b8a020ad5b33834984a437aaa7d3c74c18e09a95d48aceab08c::coin::COIN`,
    scalar: 1e6
  }
};
const testnetPools = {
  DEEP_SUI: {
    address: `0x2decc59a6f05c5800e5c8a1135f9d133d1746f562bf56673e6e81ef4f7ccd3b7`,
    baseCoin: "DEEP",
    quoteCoin: "SUI"
  },
  SUI_DBUSDC: {
    address: `0xace543e8239f0c19783e57bacb02c581fd38d52899bdce117e49c91b494c8b10`,
    baseCoin: "SUI",
    quoteCoin: "DBUSDC"
  },
  DEEP_DBUSDC: {
    address: `0x1faaa544a84c16215ef005edb046ddf8e1cfec0792aec3032e86e554b33bd33a`,
    baseCoin: "DEEP",
    quoteCoin: "DBUSDC"
  },
  DBUSDT_DBUSDC: {
    address: `0x83aca040eaeaf061e3d482a44d1a87a5b8b6206ad52edae9d0479b830a38106f`,
    baseCoin: "DBUSDT",
    quoteCoin: "DBUSDC"
  }
};
const mainnetPools = {
  DEEP_SUI: {
    address: ``,
    baseCoin: "DEEP",
    quoteCoin: "SUI"
  }
};
export {
  mainnetCoins,
  mainnetPackageIds,
  mainnetPools,
  testnetCoins,
  testnetPackageIds,
  testnetPools
};
//# sourceMappingURL=constants.js.map
